<template>
	<div class="animated fadeIn">
		<b-row class="justify-content-center">
			<b-col sm="12" md="8" lg="4">
				<b-card>
					<div slot="header">
						<strong>Agregar Ticket </strong>
					</div>
					<b-card-body>
						<b-form @submit="createTicket">
							<b-form-group class="mb-4" v-if="errorMessage">
								<b-alert show variant="danger" class="m-0 w-100 text-center">{{errorMessage}}
								</b-alert>
							</b-form-group>

							<b-form-group class="mb-4" v-if="success">
								<b-alert show variant="success" class="m-0 w-100 text-center">
									El ticket se ha creado con éxito.
								</b-alert>
							</b-form-group>

							<b-form-group>
								<label><strong class="text-black-50">Nombre de Cuenta:</strong></label>
								<b-input v-model="accountAlias" type="text" readonly/>
							</b-form-group>

							<b-form-group v-if="accountSelected.HasContract">
								<label><strong class="text-black-50">Tipo de Contrato:</strong></label>
								<b-form-select v-model="ticket.contractType"
											   id="contract-type"
											   :options="contractTypeOptions"/>
								<small v-if="contractTypeError" class="text-danger">{{contractTypeError}}</small>
								<b-tooltip target="contract-type" triggers="hover">
									Si tiene un contrato de mantenimiento activo, seleccione la opción <b>Bajo Contrato</b>
								</b-tooltip>
							</b-form-group>

							<b-form-group>
								<label><strong class="text-black-50">Seleccione una prioridad:</strong></label>
								<b-form-select v-model="ticket.priority" :options="priorityOptions"/>
								<small v-if="priorityError" class="text-danger">{{priorityError}}</small>
							</b-form-group>

							<b-form-group>
								<label><strong class="text-black-50">Descripción del problema:</strong></label>
								<b-textarea v-model="ticket.description">

								</b-textarea>
								<small v-if="descriptionError" class="text-danger">{{descriptionError}}</small>
							</b-form-group>

							<b-form-group>
								<label><strong class="text-black-50">Fecha en la que pueda recibirnos:</strong></label>
								<datepicker v-model="ticket.clientDateProposed" :language="es" :bootstrap-styling=true>
								</datepicker>
								<small v-if="dateError" class="text-danger">{{dateError}}</small>
							</b-form-group>

							<b-row class="justify-content-end">
								<b-col md="12" class="text-right">
									<b-button @click="back()">Cancelar</b-button>
									&nbsp;
									<b-button v-if="!loading" type="submit" variant="primary">Crear Ticket</b-button>
									<b-button v-if="loading" variant="primary" disabled>
										<b-spinner small></b-spinner>
										Creando Ticket...
									</b-button>
								</b-col>
							</b-row>
						</b-form>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import Datepicker from 'vuejs-datepicker';
	import {es} from 'vuejs-datepicker/dist/locale'

	export default {
		name: "TicketForm",
		mounted() {
			if (this.$store.state.accountSelected !== '') {
				this.accountAlias = this.$store.state.accountSelected.alias;
				this.accountSelected = this.$store.state.accountSelected;
			} else {
				this.$router.push('/accounts/');
			}
		},
		data: function () {
			return {
				selectedPriority: null,
				priorityOptions: [
					{value: null, text: 'Seleccione una opción'},
					{value: 1, text: 'AAA'},
					{value: 2, text: 'Alta'},
					{value: 3, text: 'Media'},
					{value: 4, text: 'Baja'},
				],
				contractTypeOptions: [
					{value: null, text: 'Seleccione una opción'},
					{value: 100000000, text: 'Fuera de Contrato'},
					{value: 100000001, text: 'Dentro Contrato'},
				],
				accountAlias: '',
				es: es,
				ticket: {
					priority: null,
					description: '',
					clientDateProposed: null,
					contractType: null
				},
				loading: false,
				errorMessage: '',
				dateError: '',
				descriptionError: '',
				priorityError: '',
				contractTypeError: '',
				success: false,
				accountSelected: ''
			}
		},
		components: {
			Datepicker
		},
		methods: {
			createTicket(evt) {
				evt.preventDefault();
				this.loading = true;
				this.cleanErrors();

				if (!this.accountSelected.HasContract){
					this.ticket.contractType = 100000000;
				}

				this.$store.dispatch('createTicket', this.ticket)
					.then((response) => {
						this.success = true;
						this.cleanErrors();
						this.cleanForm();
						this.$store.dispatch('getPendingAuthTickets');
						this.$router.push('/accounts/account/tickets/');
					})
					.catch((err) => {
						console.log(err);
						if (err.status === 400 && err.data.ModelState) {
							const modelState = err.data.ModelState;
							if (modelState['incidentForm.description']) {
								this.descriptionError = modelState['incidentForm.description'][0];
							}

							if (modelState['incidentForm.priority']) {
								this.priorityError = modelState['incidentForm.priority'][0];
							}

							if (modelState['incidentForm.contractType']) {
								this.contractType = modelState['incidentForm.contractType'][0];
							}

							if (modelState['incidentForm.clientDateProposed']) {
								this.dateError = modelState['incidentForm.clientDateProposed'][0];
							}
						}
					})
					.finally(() => {
						this.loading = false;
					});
			},
			back() {
				this.$router.push('/accounts/account/tickets/');
			},
			cleanErrors() {
				this.errorMessage = '';
				this.dateError = '';
				this.priorityError = '';
				this.descriptionError = '';
				this.contractTypeError = '';
			},
			cleanForm() {
				this.ticket.description = '';
				this.ticket.priority = null;
				this.ticket.clientDateProposed = null;
				this.ticket.contractType = null;
			}
		}
	}
</script>

<style scoped>

</style>
